import { detachedDoc } from 'common/Prose/Plugins/ExtendSelection/clipboard'
import { selectionIncludesNodeType } from 'common/Prose/Toolbar/components/Format/components/utils/selectionIncludesNodeType'
import { schema } from 'prose-core'
import { type EditorView } from 'prosemirror-view'
import { isTableSelection } from '.'
import { nerudaDomSerializer } from '../nerudaDomSerializer'
import { CellSelection } from './CellSelection'

export const serializeTableForClipboard = (
  view: EditorView,
  event: ClipboardEvent,
  shouldPreventDefault: boolean = true,
  deleteContent: boolean = false,
) => {
  if (
    isTableSelection(view.state.selection) ||
    view.state.selection instanceof CellSelection ||
    selectionIncludesNodeType(schema.nodes.table, view.state)
  ) {
    let doc = detachedDoc(),
      wrap = doc.createElement('div'),
      slice = view.state.selection.content(),
      { openStart, openEnd, content } = slice

    /**
     * Let PM handle the serialization when user partially selects content from a cell.
     */
    const fragmentNodes = content.content
    if (
      fragmentNodes &&
      fragmentNodes?.length === 1 &&
      fragmentNodes[0].type.name === 'table' &&
      openStart > 3 &&
      openEnd > 3
    ) {
      return false
    }

    wrap.appendChild(nerudaDomSerializer().serializeFragment(slice.content, { document: doc }))

    event.clipboardData?.setData('text/html', wrap.innerHTML)
    event.clipboardData?.setData('text', slice.content.textBetween(0, slice.content.size, '\n\n'))

    shouldPreventDefault && event.preventDefault()
    deleteContent && view.dispatch(view.state.tr.deleteSelection())
    return true
  }
  return false
}
